import styled from 'styled-components';
import { breakpoints } from 'config/config';

export const StyledPage = styled.div`
  padding: 0 50px;

  .ant-breadcrumb {
    padding: 21px 0;
  }

  .table-currency {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .contract-title {
    color: ${(props) => props.theme.contractTextTitleColor};
    font-weight: 500;
  }

  a {
    color: inherit;
  }

  .transactions-download {
    text-decoration: underline;
    text-underline-offset: 2px;
    cursor: pointer;
    color: ${(props) => props.theme.cardSecondElement} !important;
  }

  @media only screen and (max-width: ${breakpoints.lg}px) {
    padding: 16px 16px 60px 16px;
    border-radius: 15px;
    background-color: white;
    height: 100%;

    .ant-breadcrumb {
      display: none;
    }
    
    .ant-tabs-nav-wrap{
      .ant-tabs-tab-btn {
        font-size: 1rem;
      }
    }
  }
`;
